import {
    FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST,
    FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS,
    FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE,
    CREATE_DRIVER_PARTNER_PAYOUT_REQUEST,
    CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS,
    CREATE_DRIVER_PARTNER_PAYOUT_FAILURE,
} from "../actions/types";

const initialState = {
    payouts: [],
    pagination: {},
    loading: false,
    error: null,
};

const driverPartnerPayoutReducer =
    (
        state = initialState,
        action
    ) => {
        switch (
            action.type
        ) {
            case FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST:
            case CREATE_DRIVER_PARTNER_PAYOUT_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    payouts:
                        action.payload
                            ?.items ||
                        [],
                    pagination:
                        action.payload
                            ?.pagination ||
                        {},
                };

            case CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS:
                return {
                    ...state,
                    loading: false,
                };

            case FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE:
            case CREATE_DRIVER_PARTNER_PAYOUT_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };

            default:
                return state;
        }
    };

export default driverPartnerPayoutReducer;